import { memo } from "react";
import { ACTIVITY_CATEGORY_LABELS } from "../../utils/userActivity";
import { categoryStyle, activityTitle } from "../activity/activityStyle";
import SubjectChip from "../activity/SubjectChip";

const TIME_FORMAT = new Intl.DateTimeFormat("tr-TR", { hour: "2-digit", minute: "2-digit" });

/**
 * Molekül: zaman çizelgesinde tek hareket. memo'lu — sonsuz kaydırmada yeni
 * sayfa eklenince önceki satırlar yeniden çizilmez.
 */
function ActivityItem({ item, isLast = false }) {
  const style = categoryStyle(item.category);
  const Icon = style.icon;
  // Sunucunun Türkçe başlığı (#412) — ham İngilizce işlem adı gösterilmez
  const title = activityTitle(item);
  const failed = item.success === false;

  return (
    <li className="relative flex gap-3 pb-4">
      {/* Zaman çizgisi */}
      {!isLast && <span aria-hidden="true" className="absolute left-[17px] top-9 bottom-0 w-px bg-gray-200" />}
      <span className={`relative z-10 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ring-1 ${style.tone}`}>
        <Icon className="h-4 w-4" />
      </span>
      <div className="min-w-0 flex-1 rounded-xl border border-gray-100 bg-white px-3 py-2 shadow-sm">
        <div className="flex items-start justify-between gap-2">
          <p className="min-w-0 text-sm font-Medium text-gray-800 break-words">{title}</p>
          <time className="shrink-0 text-xs tabular-nums text-gray-400" dateTime={item.timestamp}>
            {TIME_FORMAT.format(new Date(item.timestamp))}
          </time>
        </div>
        <div className="mt-1 flex flex-wrap items-center gap-1.5 text-[11px]">
          <span className="rounded-md bg-gray-100 px-1.5 py-0.5 text-gray-600">
            {ACTIVITY_CATEGORY_LABELS[item.category] || "Diğer"}
          </span>
          {item.subject?.label ? (
            <SubjectChip subject={item.subject} />
          ) : (
            item.deviceSerialNo && (
              <span className="rounded-md bg-teal-50 px-1.5 py-0.5 font-Medium text-teal-700">{item.deviceSerialNo}</span>
            )
          )}
          {failed && (
            <span className="rounded-md bg-red-50 px-1.5 py-0.5 font-Medium text-red-600">Başarısız</span>
          )}
        </div>
      </div>
    </li>
  );
}

export default memo(ActivityItem);
